import axios from 'axios';
import config from '../../config'
import { cloneDeep } from 'lodash'

const initialState = Object.entries(config.subjects).reduce((accumulator, [key, code]) => {
  if (config.hasOptionSubjects.includes(code)) return accumulator

  accumulator.push({
    code: code,
    selectedPublisher: null,
    publisherPages: [{ start: '', end: '', error: false }],
    shinkenkyuUnitRanges: [{ start: '', end: '', error: false }],
    useBeforeGrade: false,
    questionNum: '',
    selectedDifficulty: null,
    selectedMaterials: [],
    selectedWritingQuestion: true,
    selectedUseListening: false,
    selectedAthleticEvents: [],
  })
  return accumulator
}, [])

export default {
  state: {
    allConditions: cloneDeep(initialState),
    currentSubjectCondition: {},
    selectedSubject: null,
    selectedShakaiOptions: [],
    selectedGrade: null,
    selectedMaxPointValue: 1,
    selectedMaxPoint: '100',
    subjectTeachers: [],
  },

  getters: {
    // 子階層がある教科
    selectedSubjectHasChild: state => {
      return state.selectedSubject && config.hasOptionSubjects.includes(state.selectedSubject.code);
    },
    selectedSubjectOptions: (state, getters, rootState) => {
      if(!state.selectedSubject) return
      return rootState.master.allSubjects
        .filter(subject => {
          return subject.ancestry == state.selectedSubject.id
        })
    },
    selectedSubjectIsKokugo: state => {
      return state.selectedSubject && state.selectedSubject.code === config.subjects.KOKUGO;
    },
    selectedSubjectIsSugaku: state => {
      return state.selectedSubject && state.selectedSubject.code === config.subjects.SUGAKU;
    },
    selectedSubjectIsShakai: state => {
      return state.selectedSubject && state.selectedSubject.code === config.subjects.SHAKAI;
    },
    selectedGradeIsMinimum: state => {
      return state.selectedGrade && state.selectedGrade.code === config.grades.CHU1;
    },
    selectedSubjectIsSkill: state => {
      return state.selectedSubject && config.skillSubjects.includes(state.selectedSubject.code);
    },
    selectedSubjectOptionIsPublisherNone: state => {
      return state.currentSubjectCondition && config.publisherNoneSubjecs.includes(state.currentSubjectCondition.code);
    },
    // 体育実技かどうか
    selectedSubjectOptionIsTaiiku: state => {
      return state.currentSubjectCondition && state.currentSubjectCondition.code === config.subjects.TAIIKU_JITSUGI;
    },
    // apiに送るパラメータ
    sendApiParams: state => {
      const targetCodes = [state.selectedSubject?.code].concat(state.selectedShakaiOptions.map(option => option?.code))
      return state.allConditions.filter(condition => {
        return targetCodes.includes(condition.code)
      })
    },
    isValidGrade: state => gradeId => {
      return state.subjectTeachers.filter(subjectTeacher => !subjectTeacher.is_shingaku)
                                  .some(subjectTeacher => {
        return subjectTeacher.grade.id === gradeId
      })
    },
    isValidSubject: state => subjectId => {
      if(!state.selectedGrade) return false
      return state.subjectTeachers.filter(subjectTeacher => !subjectTeacher.is_shingaku)
                                  .some(subjectTeacher => {
        if (Object.values(config.shakaiOptionSubjects).includes(subjectTeacher.subject.code)) {
          return subjectTeacher.subject.id === subjectId
        }

        return subjectTeacher.grade.id === state.selectedGrade.id && subjectTeacher.subject.id === subjectId
      })
    },
    maxQuestionNum: state => {
      return state.selectedSubject && state.selectedSubject.code === config.subjects.KATEI ? 40 : 60
    }
  },

  mutations: {
    // 全教科の条件のセット
    setAllConditions(state, payload) {
      state.allConditions = payload
    },
    // 対象の科目セット
    setCurrentSubjectCondition(state, payload) {
      state.currentSubjectCondition = payload.currentSubjectCondition
    },
    // 条件変更
    changeCurrentSubjectCondition(state, payload) {
      Object.assign(state.currentSubjectCondition, payload)
    },

    // 選択中の教科
    setSelectedSubject(state, payload) {
      state.selectedSubject = payload.subject;
    },
    // 選択中の学年
    setSelectedGrade(state, payload) {
      state.selectedGrade = payload.grade;
    },
    // 選択中の配点
    setSelectedMaxPointValue(state, payload) {
      state.selectedMaxPointValue = payload.selectedMaxPointValue
    },
    setSelectedMaxPoint(state, payload) {
      state.selectedMaxPoint = payload.selectedMaxPoint
    },


    // 地歴公民選択
    setSelectedShakaiOptions(state, payload) {
      state.selectedShakaiOptions = payload.options;
    },
    addSelectedShakaiOptions(state, payload) {
      state.selectedShakaiOptions.push(payload.option)
    },
    initializeSelectedShakaiOptions(state) {
      state.selectedShakaiOptions = [];
    },

    // ページ範囲
    addPublisherPage(state) {
      state.currentSubjectCondition.publisherPages.push({ start: '', end: '', error: false})
    },
    removePublisherPage(state, payload) {
      state.currentSubjectCondition.publisherPages.splice(payload.index, 1)
    },
    updatePublisherPage(state, payload) {
      Object.assign(state.currentSubjectCondition.publisherPages[payload.index], payload.pages)
    },

    // 新研究単元番号
    addShingakuUnitRange(state) {
      state.currentSubjectCondition.shinkenkyuUnitRanges.push({ start: '', end: '', error: false})
    },
    removeShingakuUnitRange(state, payload) {
      state.currentSubjectCondition.shinkenkyuUnitRanges.splice(payload.index, 1)
    },
    updateShingakuUnitRange(state, payload) {
      Object.assign(state.currentSubjectCondition.shinkenkyuUnitRanges[payload.index], payload.pages)
    },

    // 先生アカウントが利用可能な教科
    setSubjectTeachers(state, payload) {
      state.subjectTeachers = payload
    },
  },

  actions: {
    async validate({ state, rootState, getters }) {
      const calcSortNo = (num, subject_code) => {
        let chgNo = getters.selectedSubjectHasChild ? num-1 : num
        if (config.publisherNoneSubjecs.includes(subject_code)) {
          if (subject_code === config.subjects.TAIIKU_JITSUGI) {
            chgNo -= 1
          }else {
            chgNo -= 2
          }
        }
        return chgNo
      }

      try {
        // 学年がが選択されているか
        if (!state.selectedSubject) throw '1.学年を選択してください'
        // 社会が選択されていて分野も選択されている
        if (getters.selectedSubjectHasChild && state.selectedShakaiOptions.length === 0) throw '1.社会の分野を選択してください'
        // // 学年が選択されている
        if (!getters.selectedSubjectHasChild && !state.selectedGrade) throw '2.学年を選択してください'

        getters.sendApiParams.forEach(param => {
          const subject = rootState.master.allSubjects.find(subject => subject.code === param.code)
          // 社会で複数の分野が選ばれている時、どの分野でのエラーなのかわかるように分野名を取得しておく
          const subjectName = (getters.selectedSubjectHasChild && state.selectedShakaiOptions.length > 1) ? `【${subject.name}】 ` : ''
          if (!config.publisherNoneSubjecs.includes(param.code)) {
            // 準拠教科書が選択されている
            if (!param.selectedPublisher) throw subjectName+ calcSortNo(3, param.code) +'.準拠教科書を選択してください'
            // 教科書範囲ページが正しく入力されている
            if (param.publisherPages.filter(page => page.start && page.end && !page.error).length === 0) throw subjectName+ calcSortNo(4, param.code) +'.教科書範囲を正しく入力してください'
          }
          // 配点が入力されている
          if (!state.selectedMaxPoint) throw subjectName + calcSortNo(5, param.code) + '.配点を入力してください'
          // 配点の入力が正しい
          if (state.selectedMaxPoint.match(/[^0-9]/)) throw subjectName + calcSortNo(5, param.code) + '.配点は数字のみで入力してください'
          // 小問数が入力されている
          if (!param.questionNum) throw subjectName + calcSortNo(6, param.code) + '.小問数を入力してください'
          // 小問数の入力が正しい
          if (param.questionNum.match(/[^0-9]/)) throw subjectName + calcSortNo(6, param.code) + '.小問数は数字のみで入力してください'
          // 小問数が上限を超えていない
          if (Number(getters.maxQuestionNum) < Number(param.questionNum)) throw calcSortNo(6, param.code) + `.小問数の上限を超えています`
          // 小問数が配点より小さい
          if (Number(param.questionNum) > Number(param.selectedMaxPoint)) throw subjectName + calcSortNo(6, param.code) + '.小問数が配点より小さくなるよう入力してください'
        })
      } catch (e) {
        return { status: 'error', message: e }
      }

      return { status: 'success', message: '' }
    },
    async getSubjectTeachers({ state, commit, dispatch, rootState }){
      const res = await axios.get('/api/v1/teacher/subject_teachers')
      const subjectTeachers = res.data
      commit('setSubjectTeachers', subjectTeachers)

      if(subjectTeachers && subjectTeachers.length > 0){
        const nonShingakuSubjectTeachers = subjectTeachers.filter(subjectTeacher => !subjectTeacher.is_shingaku)
        commit('setSelectedGrade', { grade: nonShingakuSubjectTeachers[0].grade })
        const subject = rootState.master.allSubjects.find(subject => subject.code === nonShingakuSubjectTeachers[0].subject.code)
        commit('setSelectedSubject', { subject: subject })
        await dispatch('initializeAllConditions')
        commit(
          'setCurrentSubjectCondition',
          { currentSubjectCondition: state.allConditions.find(condition => condition.code === (subject.code === 'sh' ? 'ch1' : subject.code)) }
        )
      }
    },
    resetSelectedSubject({ state, getters, commit }){
      if(!state.selectedGrade) return
      if(state.selectedSubject && getters.isValidSubject(state.selectedSubject.id)) return
      commit('setSelectedSubject',
        state.subjectTeachers.find(
          subjectTeacher => { return subjectTeacher.grade.id === state.selectedGrade.id }
        ).subject
      )
    },
    // 全教科の条件の初期化
    initializeAllConditions({ commit, rootGetters }) {
      let conditions = cloneDeep(initialState)
      conditions.forEach(condition => {
        condition.selectedDifficulty = rootGetters['master/difficultyStandard']
      })
      commit('setAllConditions', conditions)
      commit('initializeSelectedShakaiOptions')
    },
  },
}
